// @flow

import * as React from 'react';

type Props = {
  children: React.Node,
  isExpended: boolean,
}

type State = {
  contentRef: ?Element
}

class ExpendableTab extends React.Component<Props, State> {
  state: State = {
    contentRef: null,
  };

  render() {
    return (
      <div
        className="expandable-tab-container"
        style={this.state.contentRef ? { height: this.props.isExpended ? this.state.contentRef.clientHeight : '0px' } : {}}
      >
        <div
          className="expandable-tab-content"
          ref={(ref) => {
            if (!this.state.contentRef) {
              this.setState({ contentRef: ref });
            }
          }}
        >
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default ExpendableTab;
